import {useEffect, useState} from '@wordpress/element';

export const useCardBreakpoints = () => {
    const BREAKPOINTS = {
        xs: [0, 600],
        sm: [600, 900],
        md: [900, 1200],
        lg: [1200, Infinity]
    };

    const [cardContainerRef, setCardContainerRef] = useState(null);

    useEffect(() => {
        if (cardContainerRef) {
            const observer = new ResizeObserver(entries => {
                const entry = entries[0];
                const width = entry.contentRect.width;

                Object.keys(BREAKPOINTS).forEach(key => {
                    entry.target.classList.remove(`card-field-container--${key}`);
                });
                const key = Object.keys(BREAKPOINTS).find((key) => {
                    const [r1, r2] = BREAKPOINTS[key];
                    if (r1 < width && r2 > width) {
                        return true;
                    }
                    return false;
                });
                if (key) {
                    entry.target.classList.add(`card-field-container--${key}`);
                }
            });
            observer.observe(cardContainerRef);
            return () => {
                observer.disconnect();
            }
        }
    }, [cardContainerRef]);

    return {
        setCardContainerRef
    }
}